module.exports = __webpack_public_path__ + "static/img/buy_help_serv.c56a0ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buy_help_serv.jpg
// module id = Qyvj
// module chunks = 18